import script from "./AutomatedIncomeVerification.vue?vue&type=script&setup=true&lang=ts"
export * from "./AutomatedIncomeVerification.vue?vue&type=script&setup=true&lang=ts"

import "@/styles/measure-one-modal/m1-modal.css?vue&type=style&index=0&id=d8df9528&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d8df9528"]])

export default __exports__